// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationV2UserCreatePortalAdminCreatePortalAdminResponse {
    static getAttributeTypeMap() {
        return AuthenticationV2UserCreatePortalAdminCreatePortalAdminResponse.attributeTypeMap;
    }
}
AuthenticationV2UserCreatePortalAdminCreatePortalAdminResponse.discriminator = undefined;
AuthenticationV2UserCreatePortalAdminCreatePortalAdminResponse.additionalProperties = false;
AuthenticationV2UserCreatePortalAdminCreatePortalAdminResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=authenticationV2UserCreatePortalAdminCreatePortalAdminResponse.js.map